// 固定字段配置项
export const fixedFieldConfig = [
    {
        col: 12,
        componentType: "uploadIcon", // UI类型
        id: "position_logo", // 标签id
        labelName: "", // 标签名
        labelCode: "logo", // 标签key
        value: "this.state.formData.logo", // 值所在位置
        fieldProps: {
            style: {
                height: 79,//比较特殊，样式不可修改
                marginTop: 15
            },
            disabled: false, // 是否禁用,
        }
    },
    {
        col: 12,
        componentType: "platformSelect", // UI类型
        value: "this.state.formData.positionTypeId", // 值所在位置
        labelName: "媒体平台", // 标签名
        labelCode: "positionTypeId", // 标签key
        required: true, // 是否必填
        id: "position_positionTypeId", // 标签id
        fieldProps: {
            placeholder: "请选择媒体平台", // 空输入框提示
            message: "请选择媒体平台", // 校验提示
            size: "default", // 标签大小
            disabled: false, // 是否禁用
        },
        options: {  //规则校验
            rules: [
                {
                    pattern: "",
                    message: "",
                }
            ]
        }
    },
    {
        col: 12,
        componentType: "deptSelect", // UI类型   **********所属部门***********
        value: "this.state.formData.belongDeptId", // 值所在位置
        auth: "pms:positionManage:assignPosition",
        labelName: "所属部门", // 标签名
        labelCode: "belongDeptId", // 标签key
        required: true, // 是否必填
        id: "position_belongDeptId", // 标签id
        fieldProps: {
            placeholder: "请选择所属部门", // 空输入框提示
            message: "请选择所属部门", // 校验提示
            size: "default", // 标签大小
            disabled: false, // 是否禁用
        },
        options: {  //规则校验
            rules: [
                {
                    pattern: "",
                    message: "",
                }
            ]
        }
    },
    {
        col: 12,
        componentType: "userSelect", // UI类型   *********用户**********
        value: "this.state.formData.belongUserAccount", // 值所在位置
        auth: "pms:positionManage:assignPosition",
        labelName: "部门用户", // 标签名
        labelCode: "belongUserAccount", // 标签key
        required: false, // 是否必填
        id: "position_belongUserAccount", // 标签id
        fieldProps: {
            placeholder: "请选择部门用户", // 空输入框提示
            message: "请选择部门用户", // 校验提示
            size: "default", // 标签大小
            disabled: false, // 是否禁用
        }
    },
    {
        col: 12,
        componentType: "nameCheck", // UI类型
        value: "this.state.formData.name", // 值所在位置
        labelName: "账号名称", // 标签名
        labelCode: "name", // 标签key
        maxLength: 50, // 输入最大长度
        required: true, // 是否必填
        disabled: false, // 是否禁用
        id: "position_name", // 标签id
        regMessage: "请输入账号名称", // 校验正则不通过的提示
        fieldProps: {
            placeholder: "请输入", // 空输入框提示
            size: "default", // 标签大小
            message: "请输入账号名称", // 校验提示
            disabled: false, // 是否禁用
        },
        options: {  //规则校验
            rules: [
                {
                    pattern: "",
                    message: "",
                },
                {
                    max: 50,
                    message: "内容不能超过50个字",
                },
            ]
        }
    },
    {
        col: 12,
        componentType: "text", // UI类型
        value: "this.state.formData.status", // 值所在位置
        labelName: "备案状态", // 标签名
        labelCode: "status", // 标签key
        required: false, // 是否必填
        id: "position_status", // 标签id
    },
]